module.exports = [
  require('./bastian_thermandar'),
  require('./black_earth_guard'),
  require('./black_earth_priest'),
  require('./burrowshark'),
]
